var _excluded = ["label", "name", "info"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { LabelContainer, LabelText } from './style';
import Icon from '../Icon';
import TooltipHost from '../TooltipHost';
import Span from '../Typography/Span';
import { TooltipIcon } from '../Icons';
var InputLabel = function InputLabel(_ref) {
  var label = _ref.label,
    name = _ref.name,
    info = _ref.info,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelContainer, rest, label ? /*#__PURE__*/React.createElement(LabelText, {
    htmlFor: name
  }, label) : /*#__PURE__*/React.createElement("span", null), info && /*#__PURE__*/React.createElement(Span, null, /*#__PURE__*/React.createElement(Icon, {
    id: "info-".concat(name),
    as: TooltipIcon,
    color: "#000",
    size: "sz16"
  }))), info && /*#__PURE__*/React.createElement(TooltipHost, {
    parent: "info-".concat(name)
  }, /*#__PURE__*/React.createElement(Span, null, info)));
};
InputLabel.displayName = 'InputLabel';
export default InputLabel;